// frontend/src/components/Sidebar.js

import React from "react";
import { NavLink } from "react-router-dom";
import { IoLogOutOutline, IoGridOutline, IoAddCircleOutline } from "react-icons/io5";

function Sidebar({ handleLogout }) {
  // Estilos para os links de navegação
  const linkStyle = "flex items-center px-4 py-3 text-gray-200 hover:bg-gray-700 rounded-lg transition-colors";
  const activeLinkStyle = "bg-gray-900 font-semibold";

  return (
    <div className="w-64 bg-gray-800 text-white h-screen flex flex-col p-4 shadow-lg">
      {/* Logo/Título */}
      <div className="text-center py-6">
        <h1 className="text-2xl font-bold tracking-widest text-blue-400 uppercase">TBM QR Codes</h1>
      </div>

      {/* Navegação Principal */}
      <nav className="flex-grow">
        <ul>
          <li>
            <NavLink 
              to="/dashboard" 
              end // A propriedade 'end' garante que este link só fica ativo na página exata do dashboard
              className={({ isActive }) => `${linkStyle} ${isActive ? activeLinkStyle : ""}`}
            >
              <IoGridOutline className="mr-3 text-xl" />
              Minhas Coleções
            </NavLink>
          </li>
          <li className="mt-2">
            <NavLink 
              to="/dashboard/create"
              className={({ isActive }) => `${linkStyle} ${isActive ? activeLinkStyle : ""}`}
            >
              <IoAddCircleOutline className="mr-3 text-xl" />
              Criar Novo QR Code
            </NavLink>
          </li>
        </ul>
      </nav>

      {/* Botão de Logout */}
      <div className="mt-auto">
        <button
          onClick={handleLogout}
          className="flex items-center w-full px-4 py-3 text-red-400 hover:bg-red-900 hover:text-red-300 rounded-lg transition-colors"
        >
          <IoLogOutOutline className="mr-3 text-xl" />
          <span>Sair</span>
        </button>
      </div>
    </div>
  );
}

export default Sidebar;